import { render, staticRenderFns } from "./FiltrateInfo.vue?vue&type=template&id=26815341&scoped=true"
import script from "./FiltrateInfo.vue?vue&type=script&lang=js"
export * from "./FiltrateInfo.vue?vue&type=script&lang=js"
import style0 from "./FiltrateInfo.vue?vue&type=style&index=0&id=26815341&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26815341",
  null
  
)

export default component.exports